/**
 * Derives the React Router basename from the current URL path.
 * When the app is served under a /search/ prefix (e.g. web.inresiapp.com/search/)
 * the basename is "/search"; otherwise it is "/" for clean-URL deployments and
 * the local dev server.
 */
export const APP_BASENAME =
  typeof window !== "undefined" &&
  window.location.pathname.split("/")[1] === "search"
    ? "/search"
    : "/";
